"use client";
import { CommentReaction } from "@prisma/client";
import { useEffect, useState } from "react";
import { updateReactions } from "./updateReactions";

type props = {
  commentId: string;
  userId: string;
};

const options = ["up", "down", "heart", "joy", "fire"];

const Reactions = ({ commentId, userId }: props) => {
  const [reactions, setReactions] = useState<CommentReaction[]>([]);
  useEffect(() => {
    updateReactions({ commentId, userId }).then(setReactions);
  }, [commentId, userId]);

  const handleReaction = (reaction: string) => {
    const action = reactions.some(
      (r) => r.createdBy === userId && r.reaction === reaction
    )
      ? "decrease"
      : "increase";

    updateReactions({ commentId, userId, reaction, action }).then(setReactions);
  };

  return (
    <div className=" mt-2 inline-flex items-center gap-2 rounded-full bg-gray-100 px-2 py-1">
      {options.map((reaction) => (
        <button
          className="text-base"
          onClick={() => handleReaction(reaction)}
          key={reaction}
        >
          <span>
            {reaction === "smile" && "😀"}
            {reaction === "fire" && "🔥"}
            {reaction === "joy" && "😂"}
            {reaction === "heart" && "❤️"}
            {reaction === "down" && "👎"}
            {reaction === "up" && "👍"}
          </span>
          <span className="mx-1 text-gray-600">
            {reactions.filter((r) => r.reaction === reaction).length || ""}
          </span>
        </button>
      ))}
    </div>
  );
};

export default Reactions;
